import UserListReducer from './UserListReducer';

export default from './UserListContainer';
export const UserListReducers = {
  UserListReducer,
};
